import React from 'react';
import { Modal, Typography } from 'antd';
import { useLocation } from 'react-router-dom';
import { usePaymentProfile } from '../context/payment-profile';
import { PaymentDataForm } from './payment-data-form';

/**
 * Popup "Completa tus datos personales": si al usuario logueado le faltan sus datos
 * OBLIGATORIOS (nombre + email válido + términos aceptados → `complete` del backend), se abre
 * en el Home apenas entra.
 *
 * 🔒 BLOQUEO DURO (feedback 2026-07-13): mientras falte alguno de los 3, el modal NO se puede
 * cerrar de ninguna forma — sin cruz, sin Escape, sin click afuera, sin botón Cancelar. La
 * única salida es completar los 3 y tocar "Aceptar" (que guarda). El Alias de Mercado Pago es
 * opcional y NO bloquea. Al quedar completo, el popup se cierra solo. Se monta dentro de
 * PaymentProfileProvider.
 */
export const PaymentDataGate: React.FC = () => {
  const { profile, loading, complete } = usePaymentProfile();
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '';
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    // Abrir en Home si faltan datos obligatorios; cerrar apenas el perfil quede completo.
    if (complete) setOpen(false);
    else if (isHome && !loading && profile) setOpen(true);
  }, [isHome, loading, profile, complete]);

  return (
    <Modal
      title='Completa tus datos personales'
      open={open}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      destroyOnClose
    >
      <Typography.Text type='secondary' style={{ display: 'block', marginBottom: 14 }}>
        Necesitamos estos datos para poder pagarte tus premios. El <strong>nombre</strong>, el{' '}
        <strong>email</strong> y la aceptación de los términos son obligatorios para usar la app.
        El Alias de Mercado Pago es opcional y podés cargarlo más tarde desde Ajustes.
      </Typography.Text>
      <PaymentDataForm
        submitLabel='Aceptar'
        emailLabel='Email'
        onSaved={() => setOpen(false)}
      />
    </Modal>
  );
};
